/**
 * Shared password validation schema used across all auth forms.
 *
 * Rules (must match backend auth.config.ts):
 *   - 8–32 characters
 *   - At least one letter (a-z / A-Z)
 *   - At least one digit (0-9)
 *   - At least one special character
 */
import { z } from 'zod';

const SPECIAL_RE = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/;

export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .max(32, 'Password must be at most 32 characters')
  .refine((v) => /[a-zA-Z]/.test(v), {
    message: 'Password must contain at least one letter',
  })
  .refine((v) => /\d/.test(v), {
    message: 'Password must contain at least one number',
  })
  .refine((v) => SPECIAL_RE.test(v), {
    message: 'Password must contain at least one special character',
  });

/** Human-readable hint shown below password inputs. */
export const PASSWORD_HINT =
  '8–32 characters, including a letter, number, and special character.';
